module.exports = __webpack_public_path__ + "img/3-3.7d689e37.png";